import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';
import { useBreakpoint } from '../../styles/breakpoints';
import { NavLink } from 'react-router-dom';
import { Icon } from './Icon';
import { IconDefinitions } from '../..';

export interface NavigationItemProps {
  item: {
    text: string;
    url: string;
    icon: string;
  }
  style?: React.CSSProperties;
  onClick?: () => void;
}

const StyledNavigationItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-left: 2.5rem;
`;

const StyledLink = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;

  font-size: 1.125rem;
  
  cursor: pointer;
  &:hover {
    @media (pointer: fine) {
      color: ${Colors.tertiary};
    }
  }
  &.active {
    color: ${Colors.tertiary};
  }
`;

const Label = styled.div`
  margin-left: .25rem;
`;

export const NavigationItem: FC<NavigationItemProps> = (props) => {
  const { item, style, onClick } = props;
  return (
    <StyledNavigationItem style={style}>
      <StyledLink to={item.url} onClick={() => onClick && onClick()}>
        <Icon icon={item.icon as IconDefinitions} size={24} />
        <Label>{ item.text }</Label>
      </StyledLink>
    </StyledNavigationItem>
  );
};
